const Learning = () => import("./views/Learning.vue");

const CourseLocks = () => import("./views/CourseLocks.vue");
const CourseAssignmentsAutomation = () =>
  import("./views/CourseAssignmentsAutomation.vue");
const AdminCourseAssignmentEdit = () =>
  import("./views/CourseAssignmentEdit.vue");

export const learningRoutes = [
  {
    path: "/admin/learning",
    name: "AdminLearning",
    component: Learning,
  },
  {
    path: "/admin/learning/assign-course/:id/:accountId?",
    name: "AdminCourseAssignmentEdit",
    component: AdminCourseAssignmentEdit,
    props: true,
  },
  {
    path: "/admin/learning/automated-assignments",
    name: "CourseAssignmentsAutomation",
    component: CourseAssignmentsAutomation,
    props: true,
  },
  {
    path: "/admin/learning/course-locks",
    name: "AdminCourseLocks",
    component: CourseLocks,
  },
];
